import React from 'react';
import WrittenReviewCommentItem from './WrittenReviewCommentItem';
import useStyles from './useStyles';

import { CapaRfqReview } from '@generated/graphql';
import { CircularProgress } from '@material-ui/core';
import {
  CustomizedButton,
  CustomizedTypography,
  Stack
} from '@components/Customized';
import { ChevronDown } from '@carbon/icons-react';

interface Props {
  loading: boolean;
  writtenReviews?: CapaRfqReview[];
  invisibleMoreButton: boolean;
  handleVisibleCount: () => void;
}

const WrittenReviewPresenter = ({
  loading,
  writtenReviews,
  invisibleMoreButton,
  handleVisibleCount
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Stack className={classes.editInfo} padding={12}>
        <CustomizedTypography
          variant="body2"
          fontWeight="500"
          color="textSecondary"
        >
          *리뷰 수정은 작성 후 1시간 이내만 가능합니다.
        </CustomizedTypography>
      </Stack>

      {writtenReviews?.length === 0 && (
        <div className="no-review">
          {loading ? (
            <CircularProgress />
          ) : (
            <CustomizedTypography variant="h4" color="textSecondary">
              작성한 리뷰가 없습니다.
            </CustomizedTypography>
          )}
        </div>
      )}

      {writtenReviews?.map((review, index) => (
        <WrittenReviewCommentItem
          key={review.reviewedAt}
          index={index}
          review={review}
        />
      ))}

      {!invisibleMoreButton && (
        <div className={classes.visibie}>
          <CustomizedButton
            size="medium"
            color="default"
            onClick={handleVisibleCount}
            endIcon={<ChevronDown size={20} />}
          >
            더보기
          </CustomizedButton>
        </div>
      )}
    </div>
  );
};

export default WrittenReviewPresenter;
